export const INVOICE_PRINT_PROFILE_KEY = 'invoicePrintProfile';

export const INVOICE_PRINT_PROFILES = [
  { value: 'a4', label: 'A4 (Standard)' },
  { value: 'thermal80', label: 'Thermal 80mm' },
  { value: 'thermal58', label: 'Thermal 58mm' }
];

const VALID_PROFILES = new Set(INVOICE_PRINT_PROFILES.map((profile) => profile.value));

export const normalizeInvoicePrintProfile = (profile) => {
  const value = String(profile || '').trim().toLowerCase();
  return VALID_PROFILES.has(value) ? value : 'a4';
};

export const getStoredInvoicePrintProfile = () => {
  if (typeof window === 'undefined') {
    return 'a4';
  }
  return normalizeInvoicePrintProfile(localStorage.getItem(INVOICE_PRINT_PROFILE_KEY));
};

export const setStoredInvoicePrintProfile = (profile) => {
  if (typeof window === 'undefined') {
    return;
  }
  const normalized = normalizeInvoicePrintProfile(profile);
  localStorage.setItem(INVOICE_PRINT_PROFILE_KEY, normalized);
};

export const resolveInvoicePrintProfile = (templateData = null) => {
  return normalizeInvoicePrintProfile(templateData?.printProfile || getStoredInvoicePrintProfile());
};

const getThermalWidthMm = (profile) => {
  return normalizeInvoicePrintProfile(profile) === 'thermal58' ? 58 : 80;
};

export const getInvoicePrintCss = (profile) => {
  const normalized = normalizeInvoicePrintProfile(profile);

  if (normalized === 'a4') {
    return '@page{size:A4;margin:0} html,body{margin:0;padding:0;background:#fff} *{-webkit-print-color-adjust:exact; print-color-adjust:exact}';
  }

  const widthMm = getThermalWidthMm(normalized);
  return `@page{size:${widthMm}mm auto;margin:0}
html,body{margin:0;padding:0;background:#fff;width:${widthMm}mm;max-width:${widthMm}mm}
*{-webkit-print-color-adjust:exact; print-color-adjust:exact; box-sizing:border-box}
body > div, div[style*="max-width: 1024px"]{max-width:100% !important;width:100% !important;padding:6px !important;border:0 !important}
div[style*="grid-template-columns: 1fr 1fr"]{display:block !important}
div[style*="grid-template-columns: repeat(auto-fit"]{display:block !important}
table{width:100% !important;table-layout:fixed}
th,td{font-size:10px !important;padding:4px !important;word-break:break-word}
table th:nth-child(4),table td:nth-child(4),table th:nth-child(5),table td:nth-child(5),table th:nth-child(6),table td:nth-child(6),table th:nth-child(7),table td:nth-child(7){display:none !important}`;
};

export const getInvoiceHtml2PdfOptions = (profile, filename = 'invoice.pdf') => {
  const normalized = normalizeInvoicePrintProfile(profile);

  if (normalized === 'a4') {
    return {
      margin: 0.5,
      filename,
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
  }

  const widthMm = getThermalWidthMm(normalized);
  return {
    margin: 0,
    filename,
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: [400, widthMm], orientation: 'portrait' }
  };
};
